mutation UpdateRole($roleInput: RoleInput!) {
  updateRole(input: { roleInput: $roleInput }) {
    role {
      id
      name
      permissions {
        id
        name
      }
    }
  }
}
